import {popViewAction} from '../../redux/actions/Actions';
import {appStore} from '../../redux/createStore';
import Smartlook from '../../utils/smartlook';
import {sendScreenViewNR} from '../../utils/util';

import {Button} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import './accountConfiguration.css';

const AccountConfiguration = (props) => {
  const {t} = useTranslation();

  const handleClick = () => {
    if (props.viewListLength > 1) {
      appStore.dispatch(popViewAction());
    }
    props.redirectHome();
  };
  React.useEffect(() => {
    sendScreenViewNR('accountConfiguration');
    Smartlook.navigation('accountConfiguration');
  }, []);

  return (
    <div className={'accountConfigurationWrapper'}>
      <div className={'accountSetupHeader'}>
        <div className={'accountCreatedTitle'}>{t('ACCOUNT_SETUP_TITLE')}</div>
        <div className={'accountCreatedDesc'}>{t('ACCOUNT_SETUP_DESC')}</div>
      </div>
      <div className={'accountSetupBtn'}>
        <Button
          id="submitButton"
          variant="secondary"
          onClick={() => {
            globalThis.location.href = `${import.meta.env.VITE_ACCOUNT_SETUP}`;
          }}
        >
          {t('CONTINUE_ACCOUNT_SETUP')}
        </Button>
        <Button id="Home_btn" variant="secondary" onClick={handleClick}>
          {t('MANAGE_FINANCIAL_ACCOUNT')}
        </Button>
      </div>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    viewListLength: state.appStates.viewList.length,
  };
};
export default connect(mapStateToProps)(AccountConfiguration);
